/*
 *
 * Package: `@dbh/shopping-cart-page-theme`.
 *
 */const THEME_KEY_SHOPPING_CART_PAGE="shoppingCartPage";const modifyShoppingCartTheme=a=>{let{spacing:{sp6:b}}=a;return {[THEME_KEY_SHOPPING_CART_PAGE]:{columnsLeftRightPadding:b}}};

export { THEME_KEY_SHOPPING_CART_PAGE, modifyShoppingCartTheme as default };
